import { render, staticRenderFns } from "./InputUploader.vue?vue&type=template&id=2a2b78b1&scoped=true&"
import script from "./InputUploader.vue?vue&type=script&lang=ts&"
export * from "./InputUploader.vue?vue&type=script&lang=ts&"
import style0 from "./InputUploader.vue?vue&type=style&index=0&id=2a2b78b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2b78b1",
  null
  
)

export default component.exports